import React, { useCallback } from "react";
import { getNextSibling, getPreviousSibling } from "./dom-query";

var FocusTrapWrapper = function FocusTrapWrapper(_ref) {
  var children = _ref.children,
      _ref$closePopup = _ref.closePopup,
      closePopup = _ref$closePopup === void 0 ? null : _ref$closePopup,
      _ref$focusElements = _ref.focusElements,
      focusElements = _ref$focusElements === void 0 ? ["button", "a", "input", "select"] : _ref$focusElements,
      id = _ref.id;
  var queryId = focusElements.map(function (el) {
    return "#".concat(id, "-focus-trap ").concat(el, ":not([disabled])");
  }).join(", ");
  var handleKeyDown = useCallback(function (e) {
    var element = e.target;

    switch (e.key) {
      case "Escape":
        closePopup();
        break;

      case "Tab":
        e.preventDefault();

        if (e.shiftKey) {
          var _getPreviousSibling;

          (_getPreviousSibling = getPreviousSibling(queryId, element)) === null || _getPreviousSibling === void 0 ? void 0 : _getPreviousSibling.focus();
        } else {
          var _getNextSibling;

          (_getNextSibling = getNextSibling(queryId, element)) === null || _getNextSibling === void 0 ? void 0 : _getNextSibling.focus();
        }

        break;

      default:
    }
  }, [closePopup]);
  return /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "-focus-trap"),
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, children);
};

export { getNextSibling, getPreviousSibling };
export default FocusTrapWrapper;
//# sourceMappingURL=index.js.map